// import logo from './logo.svg';
// import './App.css';
// const Readline = require('@serialport/parser-readline')
// let bufferedString = ""

// function App() {
//   function sleep(ms) {
//     return new Promise((resolve) => {
//       setTimeout(resolve, ms);
//     });
//   } 

//   function parse(data) {
//     var enc = new TextDecoder("utf-8");
//     if (data.byteLength !== 2) {
//       let rd = enc.decode(data.buffer)
//       console.log(rd)
//       bufferedString += rd.substr(2)
      
//       if (rd.slice(-1) === '\n') {
//         try {
//           console.log(bufferedString)
//           console.log(bufferedString.length)
//           console.log(JSON.parse(bufferedString))
//           bufferedString = ``
          
//         } catch (e) {
//           bufferedString = ``
//           console.log(e)
//         }
        
//       }
      
      

//     }
    
//   }

//   async function connect() {
//     // try {
      
//     try {
      
//       const device = await navigator.usb.requestDevice({ filters: [] })
//       await device.open()
//       await device.reset()
//       await device.selectConfiguration(1)
//       await device.claimInterface(0)
//       while (true) {
//         let x = await device.transferIn(1, 512)
//         parse(x.data)
//         // var enc = new TextEncoder(); // always utf-8
//         // var d = enc.encode("This is a string converted to a Uint8Array")
//         // await device.transferOut(2, d)
//       }
      
      
//     } catch(e) {
//        console.log(e)
//      }
//     //   .then(selectedDevice => {
//     //     device = selectedDevice;
//     //     return device.open();
//     //   })
//     //   .then(() => device.selectConfiguration(1)) // Select configuration #1 for the device.
//     //   .then(() => device.claimInterface(1)) 
//     // .then(() => device.transferIn(3, 64)) 
    
//     // .then(result => {
//     //   const decoder = new TextDecoder();
//     //   console.log('Received: ' + decoder.decode(result.data));
//     // })
//     // .catch(error => { console.error(error); });
//     // } catch (e) {
//     //   console.log("err")
//     //   console.log(e)
//     // }


//     // navigator.usb.addEventListener('connect', (event) => {
//     //   this.push('devices', event.device);
//     //   connectDevice(event.device);
//     // });

//     // navigator.usb.addEventListener('disconnect', (event) => {
//     //   let index = this.devices.indexOf(event.device);
//     //   this.splice('devices', index, 1);
//     // });
//   }

//   return (
//     <div className="App">
//       <button onClick={connect} >Activate Lasers</button>
//     </div>
//   );
// }

// export default App;


import  Example  from './main'

function App() {
  return (
    <div className="App">
      <Example></Example>
    </div>
  );
}

export default App;
